import {modelChecklist, modelConectaPro, modelSellerApp, modelWhatsapp, modelWhatsappOficial} from "../../models/service-activation";

import { ConectaProController } from "./conecta-pro-controller";
import { SellerAppController } from "./seller-app-controller";
import { ChecklistController } from "./checklist-controller";
import { WhatsappController } from "./whatsapp-controller";
import { WhatsappOficialController } from "./whatsapp-oficial-controller";


let conectaProController = null;
let sellerAppController = null;
let checklistController = null;
let whatsappController = null;
let whatsappOficialController = null;

export function controllerWhatsapp() {
  if (!whatsappController) {
    whatsappController = new WhatsappController({
      models: {
        whatsapp: modelWhatsapp(),
      }
    })
  }
  return whatsappController;
}

export function controllerChecklist() {
  if (!checklistController) {
    checklistController = new ChecklistController({
      models: {
        checklist: modelChecklist(),
      }
    })
  }
  return checklistController;
}

export function controllerConectaPro() {
  if (!conectaProController) {
    conectaProController = new ConectaProController({
      models: {
        conectaPro: modelConectaPro(),
      }
    })
  }
  return conectaProController;
}
export function controllerSellerApp() {
  if (!sellerAppController) {
    sellerAppController = new SellerAppController({
      models: {
        sellerApp: modelSellerApp(),
      }
    })
  }
  return sellerAppController;
}

export function controllerWhatsappOficial() {
  if (!whatsappOficialController) {
    whatsappOficialController = new WhatsappOficialController({
      models: {
        whatsappOficial: modelWhatsappOficial(),
      }
    })
  }
  return whatsappOficialController;
}
